import { useState } from 'react';
import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import { GetPostTextInfoParams, PostsApi } from 'app/modules/posts/api/posts';
import { CharacterCounterCountConfig } from 'app/modules/textEditor/components/optionsBar/CharacterCounter';

export const usePostTextCharacterCounts = ({
  text,
  pageType,
}: GetPostTextInfoParams) => {
  const [countData, setCountData] = useState<CharacterCounterCountConfig>({
    characters: 0,
    hashtags: 0,
    mentions: 0,
  });
  useQuery(
    queryKey.postTextInfo({ text, pageType }),
    () => PostsApi.textInfo({ text, pageType }),
    {
      onSuccess: (data) => {
        setCountData({
          characters: data.textLength,
          hashtags: data.hashtags,
          mentions: data.mentions,
        });
      },
    },
  );

  return countData;
};
